<template>
  <van-popup
    v-model="visible"
    position="bottom"
    :close-on-click-overlay="false"
    @click-overlay="close"
    @close="onClose"
  >
    <div class="block">
      <img
        src="@/assets/groupRob/close.png"
        alt=""
        class="close"
        @click="close"
      />
      <div class="title">{{ title }}</div>
      <div class="content" v-html="html"></div>
    </div>
  </van-popup>
</template>

<script>
export default {
  model: {
    prop: "visible",
    event: "visibleChange",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    html: String,
    title: String,
  },
  methods: {
    close() {
      this.$emit("visibleChange", false);
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.van-popup {
  height: 80vh;
  border-radius: 1.5rem 1.5rem 0 0;
  overflow: hidden;
}

.block {
  padding: 0 1.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .title {
    padding: 1.5rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
  }

  .close {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    width: 1.8rem;
    height: 1.8rem;
  }

  .content {
    box-sizing: border-box;
    height: calc(80vh - 5rem);
    overflow: auto;
    font-size: 1.2rem;
    line-height: 1.5;
    padding-bottom: 1.5rem;

    ::deep(img) {
      max-width: 100%;
    }
  }
}
</style>
